// extracted by mini-css-extract-plugin
export default {"btn":"TrxInfo_btn--Hbz","info":"TrxInfo_info--hDZ"};